export const MIN_DAYS_CONVERSATION_REFUND = 3

export const MAX_DAYS_CONVERSATION_REFUND = 30